var $jscomp = $jscomp || {};
$jscomp.scope = {};
$jscomp.createTemplateTagFirstArg = function(h) {
  return h.raw = h;
};
$jscomp.createTemplateTagFirstArgWithRaw = function(h, m) {
  h.raw = m;
  return h;
};
$jscomp.arrayIteratorImpl = function(h) {
  var m = 0;
  return function() {
    return m < h.length ? {done:!1, value:h[m++],} : {done:!0};
  };
};
$jscomp.arrayIterator = function(h) {
  return {next:$jscomp.arrayIteratorImpl(h)};
};
$jscomp.makeIterator = function(h) {
  var m = "undefined" != typeof Symbol && Symbol.iterator && h[Symbol.iterator];
  if (m) {
    return m.call(h);
  }
  if ("number" == typeof h.length) {
    return $jscomp.arrayIterator(h);
  }
  throw Error(String(h) + " is not an iterable or ArrayLike");
};
$jscomp.arrayFromIterator = function(h) {
  for (var m, g = []; !(m = h.next()).done;) {
    g.push(m.value);
  }
  return g;
};
$jscomp.arrayFromIterable = function(h) {
  return h instanceof Array ? h : $jscomp.arrayFromIterator($jscomp.makeIterator(h));
};
(function() {
  var h = !1, m = !1;
  theme.PriceRange = function() {
    function g(e, d) {
      var a = void 0 === d ? {} : d, b = a.onChange;
      a = a.onUpdate;
      this.container = e;
      this.onChange = b;
      this.onUpdate = a;
      return this.init();
    }
    function f(e, d) {
      var a;
      return function(b) {
        clearTimeout(a);
        a = setTimeout(function() {
          e.apply(this, b);
        }, d);
      };
    }
    g.prototype = Object.assign({}, g.prototype, {init:function() {
      var e = this;
      if (!this.container.classList.contains("price-range")) {
        throw Error("You must instantiate PriceRange with a valid container");
      }
      this.formEl = this.container.closest("form");
      this.sliderEl = this.container.querySelector(".price-range__slider");
      this.inputMinEl = this.container.querySelector(".price-range__input-min");
      this.inputMaxEl = this.container.querySelector(".price-range__input-max");
      this.displayMinEl = this.container.querySelector(".price-range__display-min");
      this.displayMaxEl = this.container.querySelector(".price-range__display-max");
      this.inputMinEl.addEventListener("keyup", f(function() {
        if (e.onChange) {
          var d = new FormData(e.formEl);
          h = !0;
          e.onChange(d);
        }
      }, 1000));
      this.inputMaxEl.addEventListener("keyup", f(function() {
        if (e.onChange) {
          var d = new FormData(e.formEl);
          m = !0;
          e.onChange(d);
        }
      }, 1000));
    }});
    return g;
  }();
  theme.reinitProductGridItem = function(g) {
    window.SPR && (SPR.initDomEls(), SPR.loadBadges());
    theme.collapsibles.init();
  };
  theme.Filter = function() {
    function g(f) {
      f = void 0 === f ? {} : f;
      var e = f.onReplace;
      this.sections = f.sections || [];
      this.cachedSections = [];
      this.onReplace = e;
    }
    g.prototype = Object.assign({}, g.prototype, {_onFilterChange:function(f, e, d) {
      var a = this;
      d = void 0 === d ? !0 : d;
      var b = new URLSearchParams(window.location.search), c = this._initParams(b, e);
      e = this.sections.map(function(k) {
        var l = f + "?section_id=" + k.sectionId + "&" + c.toString(), n = function(p) {
          return p.url === l;
        };
        return a.cachedSections.some(n) ? a._restoreSection(n, k) : a._loadSection(l, k);
      });
      d && this._updateURLHash(c);
      return Promise.all(e);
    }, _initParams:function(f, e) {
      for (var d = new URLSearchParams(f), a = ["sort_by", "q", "options[prefix]", "type"], b = $jscomp.makeIterator(d.entries()), c = b.next(); !c.done; c = b.next()) {
        var k = $jscomp.makeIterator(c.value);
        c = k.next().value;
        k = k.next().value;
        e.getAll(c).includes(k) || a.includes(c) || d["delete"](c);
      }
      a = $jscomp.makeIterator(e.entries());
      for (b = a.next(); !b.done; b = a.next()) {
        c = $jscomp.makeIterator(b.value), b = c.next().value, c = c.next().value, d.getAll(b).includes(c) || "" === c || d.append(b, c);
      }
      return d;
    }, _restoreSection:function(f, e) {
      var d = this.cachedSections.find(f);
      this._updateSection(d.html, e);
      return Promise.resolve(e);
    }, _loadSection:function(f, e) {
      var d = this;
      return new Promise(function(a, b) {
        fetch(f).then(function(c) {
          return c.text();
        }).then(function(c) {
          d.cachedSections = [d.cachedSections, {html:c, url:f}];
          d._updateSection(c, e);
          a(e);
        })["catch"](function(c) {
          return b(c);
        });
      });
    }, _updateSection:function(f, e) {
      var d = (new DOMParser()).parseFromString(f, "text/html");
      if (this.onReplace) {
        this.onReplace(d, e);
      } else {
        if ("string" === typeof e.nodeId) {
          var a = d.getElementById(e.nodeId);
          if (!a) {
            return;
          }
          document.getElementById(e.nodeId).innerHTML = a.innerHTML;
        } else {
          e.nodeId.forEach(function(b) {
            document.getElementById(b).innerHTML = d.getElementById(b).innerHTML;
          });
        }
      }
      return e;
    }, _updateURLHash:function(f) {
      history.pushState({}, "", "" + window.location.pathname + (f && "?".concat(f)));
    }});
    return g;
  }();
  theme.CollectionSidebar = function() {
    function g() {
      document.getElementById(f.sidebarId) && (document.addEventListener("filter:selected", this.close.bind(this)), this.init());
    }
    var f = {sidebarId:"CollectionSidebar", trigger:".filters-toolbar__btn", mobileWrapper:"#CollectionInlineFilterWrap", filters:".filter-wrapper", filterBar:".filters-toolbar"}, e = !1;
    g.prototype = Object.assign({}, g.prototype, {init:function() {
      e = !1;
      slate.a11y.unlockMobileScrolling(".filters-toolbars");
      this.container = document.getElementById(f.sidebarId);
      this.trigger = document.querySelector(f.trigger);
      this.wrapper = document.querySelector(f.mobileWrapper);
      this.filters = this.wrapper.querySelector(f.filters);
      null != this.trigger && (this.trigger.off("click"), this.trigger.on("click", this.toggle.bind(this)));
    }, toggle:function() {
      e ? this.close() : this.open();
    }, open:function() {
      var d = this.resize();
      window.scrollTo({top:d, behavior:"smooth"});
      this.trigger.classList.add("is-active");
      document.querySelector(f.filterBar).style.zIndex = 28;
      document.documentElement.classList.add("js-drawer-open");
      theme.Helpers.prepareTransition(this.filters, function() {
        this.filters.classList.add("is-active");
      }.bind(this));
      e = !0;
      this.bindEvents();
    }, close:function(d) {
      d && "touchend" == d.type && d.target.closest(".collection-mobile-filters") || (null != this.trigger && this.trigger.classList.remove("is-active"), theme.Helpers.prepareTransition(this.filters, function() {
        this.filters.classList.remove("is-active");
      }.bind(this)), e = !1, document.querySelector(f.filterBar).style.zIndex = 27, setTimeout(function() {
        document.documentElement.classList.remove("js-drawer-open");
      }, 50), this.unbindEvents());
    }, resize:function() {
      var d = document.querySelector("#SiteHeader"), a = document.querySelector("#AnnouncementWrapper"), b = document.querySelector(".filters-toolbar"), c = b.offsetHeight;
      b = b.getBoundingClientRect().top;
      var k = window.pageYOffset || document.documentElement.scrollTop, l = 0;
      null != a && "true" == a.dataset.sticky && (l += a.offsetHeight);
      null != d && "true" == d.dataset.sticky && (l += d.offsetHeight);
      document.documentElement.style.setProperty("--filtersHeight", window.innerHeight - l - c + "px");
      return b + k - l;
    }, onSelect:function() {
      this.open();
    }, bindEvents:function() {
      window.on("touchend.filters-toolbars", function(d) {
        d.target.closest(".filters-toolbar__btn") || this.close(d);
      }.bind(this));
      window.on("keyup.filters-toolbars", function(d) {
        27 === d.keyCode && this.close();
      }.bind(this));
      slate.a11y.lockMobileScrolling(".filters-toolbars");
    }, unbindEvents:function() {
      window.off("touchend.filters-toolbars");
      window.off("keyup.filters-toolbars");
      slate.a11y.unlockMobileScrolling(".filters-toolbars");
    }});
    return g;
  }();
  theme.Collection = function() {
    function g(a) {
      this.container = a;
      this.containerId = a.id;
      this.sectionId = a.getAttribute("data-section-id");
      this.namespace = ".collection-" + this.sectionId;
      this.isCollectionTemplate = this.container.dataset.collectionTemplate;
      this.filterSelect = new theme.Filter({sections:[{sectionId:this.sectionId, nodeId:"CollectionFilteredContent"}], onReplace:this.onReplaceAjaxContent.bind(this), preserveParams:["sort_by"],});
      this.init(a);
    }
    function f(a) {
      a.focus();
      "number" == typeof a.selectionStart ? a.selectionStart = a.selectionEnd = a.value.length : "undefined" != typeof a.createTextRange && (a = a.createTextRange(), a.collapse(!1), a.select());
    }
    var e, d = !1;
    g.prototype = Object.assign({}, g.prototype, {init:function(a) {
      d = !1;
      a || (this.container = document.getElementById(this.containerId));
      this.isCollectionTemplate && (this.initMobileFilters(), this.initSort(), this.initFilters(), this.initPriceRange(), new theme.ProductGrid(this.container), this.initInfiniteScroll(), this.sidebar = new theme.CollectionSidebar());
      this.resizeContainer();
      window.on("resize" + this.namespace, this.resizeContainer.bind(this));
    }, initSort:function() {
      var a = this;
      this.queryParams = new URLSearchParams(window.location.search);
      this.sortSelect = document.querySelector("#SortBy");
      this.sortBtns = document.querySelectorAll(".filter-sort");
      (this.sortSelect || this.sortBtn) && this.initParams();
      this.sortSelect && (this.defaultSort = this.sortSelect.getAttribute("data-default-sortby"), this.sortSelect.addEventListener("change", function() {
        this.onSortChange();
      }.bind(this)));
      this.sortBtns.length && this.sortBtns.forEach(function(b) {
        b.addEventListener("click", function() {
          document.dispatchEvent(new Event("filter:selected"));
          this.queryParams.sort_by = b.dataset.value;
          this.goToSortUrl();
        }.bind(a));
      });
    }, initParams:function() {
      this.queryParams = {};
      if (location.search.length) {
        for (var a = location.search.substr(1).split("&"), b = 0; b < a.length; b++) {
          var c = a[b].split("=");
          c.length && (this.queryParams[decodeURIComponent(c[0])] = decodeURIComponent(c[1]));
        }
      }
    }, resizeContainer:function() {
      var a = document.querySelector("#SiteHeader");
      var b = document.querySelector("#SiteAnnouncement");
      var c = document.querySelector("#AnnouncementWrapper");
      e = 0;
      null != c && null != b && (b = b.offsetHeight, "true" == c.dataset.sticky && (e = b));
      null != a && (c = a.offsetHeight, "true" == a.dataset.sticky && (e += c));
      document.documentElement.style.setProperty("--sticky-padding-desktop", e + 25.0 + "px");
    }, getSortValue:function() {
      return this.sortSelect.value || this.defaultSort;
    }, goToSortUrl:function() {
      this.queryParams.page && delete this.queryParams.page;
      window.location.search = decodeURIComponent(new URLSearchParams(Object.entries(this.queryParams)));
    }, onSortChange:function(a) {
      a = void 0 === a ? null : a;
      this.queryParams = new URLSearchParams(window.location.search);
      a ? this.queryParams.set("sort_by", a) : this.queryParams.set("sort_by", this.getSortValue());
      this.queryParams["delete"]("page");
      window.location.search = this.queryParams.toString();
    }, initInfiniteScroll:function() {
      var a = document.querySelector(".js-load-more");
      a && a.addEventListener("click", function(b) {
        var c = this, k = parseInt(document.querySelector("[data-all-pages]").value);
        b = parseInt(document.querySelector("[data-current-page]").value);
        document.querySelector("[data-collection-url]");
        this.classList.add("btn--loading");
        var l = document.querySelector("[data-next-url]").value, n = b + 1, p = l.replace("page=" + n, "page=" + (b + 2));
        fetch(l, {credentials:"same-origin", method:"GET"}).then(function(q) {
          return q.text();
        }).then(function(q) {
          document.querySelector("[data-next-url]").value = p;
          document.querySelector("[data-current-page]").value = n;
          q = (new DOMParser()).parseFromString(q, "text/html").querySelector(".grid-loader").innerHTML;
          document.querySelector(".grid-loader").insertAdjacentHTML("beforeend", q);
        }).then(function() {
          c.classList.remove("btn--loading");
          n < k && c.classList.remove("hide");
          n >= k && c.classList.add("hide");
        });
      });
    }, initFilters:function() {
      var a = this;
      document.querySelectorAll(".tag-list input").length && (document.addEventListener("matchSmall", this.initMobileFilters.bind(this)), this.bindBackButton(), theme.config.stickyHeader && (this.setFilterStickyPosition(), document.addEventListener("headerStickyChange", theme.Helpers.debounce(500, this.setFilterStickyPosition)), window.on("resize", theme.Helpers.debounce(500, this.setFilterStickyPosition))), document.querySelectorAll(".tag-list a").forEach(function(b) {
        b.addEventListener("click", a.onTagClick.bind(a));
      }), document.querySelectorAll(".filter-form").forEach(function(b) {
        b.addEventListener("input", a.onFormSubmit.bind(a));
      }));
    }, initPriceRange:function() {
      var a = this;
      document.querySelectorAll(".price-range").forEach(function(b) {
        return new theme.PriceRange(b, {onChange:a.renderFromFormData.bind(a),});
      });
    }, initMobileFilters:function() {
      if (!d) {
        var a = document.querySelector("#CollectionSidebarFilterWrap");
        if (a) {
          a = a.querySelector(".filter-wrapper").cloneNode(!0);
          var b = document.querySelector("#CollectionInlineFilterWrap");
          b.innerHTML = "";
          b.append(a);
          theme.collapsibles.init(b);
          d = !0;
        }
      }
    }, setActiveTag:function(a, b) {
      var c = a.querySelector(".tag__text");
      a.classList.contains("tag--active") ? a.classList.remove("tag--active") : (a.classList.add("tag--active"), b.closest("li").classList.contains("tag--remove") ? a.remove() : document.querySelectorAll(".tag-list--active-tags").forEach(function(k) {
        var l = document.createElement("li"), n = document.createElement("a");
        l.classList.add("tag", "tag--remove");
        n.classList.add("btn", "btn--small");
        n.innerText = c.innerText;
        l.appendChild(n);
        k.appendChild(l);
      }));
    }, onTagClick:function(a) {
      var b = a.currentTarget;
      document.dispatchEvent(new Event("filter:selected"));
      if (!b.classList.contains("no-ajax")) {
        a.preventDefault();
        a = b.parentNode;
        var c = new URL(b.href);
        this.setActiveTag(a, b);
        this.updateScroll(!0);
        this.startLoading();
        this.renderCollectionPage(c.searchParams);
      }
    }, onFormSubmit:function(a) {
      var b = a.target;
      document.dispatchEvent(new Event("filter:selected"));
      if (!b.classList.contains("no-ajax")) {
        a.preventDefault();
        a = b.closest("li");
        var c = b.closest("form");
        c = new FormData(c);
        this.setActiveTag(a, b);
        this.updateScroll(!0);
        this.startLoading();
        this.renderFromFormData(c);
      }
    }, onReplaceAjaxContent:function(a, b) {
      var c = this;
      this.fetchOpenCollasibleFilters().forEach(function(k) {
        a.querySelectorAll("[data-collapsible-id=" + k + "]").forEach(c.openCollapsible);
      });
      document.getElementById(b.nodeId).innerHTML = a.getElementById(b.nodeId).innerHTML;
    }, renderFromFormData:function(a) {
      a = new URLSearchParams(a);
      this.renderCollectionPage(a);
    }, renderCollectionPage:function(a, b) {
      var c = this;
      b = void 0 === b ? !0 : b;
      if (-1 < window.location.href.indexOf("collections/vendors")) {
        var k = (new URLSearchParams(window.location.search)).get("q");
        k && a.append("q", k);
      }
      this.filterSelect._onFilterChange(window.location.pathname, a, b).then(function() {
        theme.sections.reinit("collection-template");
        c.updateScroll(!1);
        theme.reinitProductGridItem();
        if (1 == h) {
          h = !1;
          var l = c.container.querySelector(".price-range__input-min");
          f(l);
        }
        1 == m && (m = !1, l = c.container.querySelector(".price-range__input-max"), f(l));
      });
    }, updateScroll:function(a) {
      var b = document.getElementById("CollectionFilteredContent").offsetTop;
      theme.config.stickyHeader && (b -= document.querySelector("#SiteHeader").offsetHeight);
      theme.config.bpSmall || (b -= 10);
      a ? window.scrollTo({top:b, behavior:"smooth"}) : window.scrollTo({top:b});
    }, bindBackButton:function() {
      window.off("popstate" + this.namespace);
      window.on("popstate" + this.namespace, function(a) {
        a && (a = new URL(window.location.href), this.renderCollectionPage(a.searchParams, !1));
      }.bind(this));
    }, fetchOpenCollasibleFilters:function() {
      var a = Array.from(document.querySelectorAll("#CollectionSidebar .collapsible-trigger.is-open")), b = Array.from(document.querySelectorAll("#CollectionInlineFilterWrap .collapsible-trigger.is-open"));
      return [].concat($jscomp.arrayFromIterable(a), $jscomp.arrayFromIterable(b)).map(function(c) {
        return c.dataset.collapsibleId;
      });
    }, openCollapsible:function(a) {
      a.classList.contains("collapsible-content") && (a.style.height = "auto");
      a.classList.add("is-open");
    }, setFilterStickyPosition:function() {
      var a = document.querySelector(".site-header").offsetHeight - 1;
      document.querySelector(".filters-toolbar").style.top = a + "px";
      var b = document.querySelector(".grid__item--sidebar");
      b && (b.style.top = a + 30 + "px");
    }, startLoading:function() {
      document.querySelector(".collection-grid__wrapper").classList.add("unload");
    }, forceReload:function() {
      this.init();
    },});
    return g;
  }();
  theme.ProductGrid = function() {
    function g(e) {
      this.container = e;
      this.type = this.container.querySelector(".product-grid").dataset.type;
      this.init();
      this.colorSwatchImages = this.container.querySelectorAll(f.colorSwatchImage);
      this.colorSwatchImages.length && (this.colorSwatches = this.container.querySelectorAll(f.colorSwatch + ":not(.disabled)"), this.initColorSwatch());
    }
    var f = {viewChange:".grid-view-btn", productGrid:".grid-product", collectionGrid:".collection-grid__wrapper", colorSwatchImage:".product__swatch-image", colorSwatch:".color-swatch--small", quickViewBtn:".js-modal-open-quick-view", activeDrawer:"drawer--is-open"};
    g.prototype = Object.assign({}, g.prototype, {init:function() {
      var e = this;
      "quick-buy" == this.type && this.container.querySelectorAll(".quick-shop--form").forEach(function(b) {
        new theme.ProductQuickBuy(b);
      });
      "quick-view" == this.type && this.container.querySelectorAll(".quick-product__btn").forEach(function(b) {
        e.viewDrawer = new theme.Drawers("ProductDrawer-" + b.dataset.productid, "view-" + b.dataset.productid);
        b.addEventListener("click", function(c) {
          c = "ProductDrawer-" + b.dataset.productid;
          if ((c = document.getElementById(c)) && "false" == c.dataset.ismodal) {
            c.setAttribute("data-ismodal", !0);
            c = "ProductDrawer-" + b.dataset.productid;
            c = document.getElementById(c).querySelector(".drawer__scrollable").firstElementChild;
            var k = document.getElementById("AddToCartForm-" + b.dataset.sectionid + "-" + b.dataset.productid);
            c.appendChild(k);
            this.Product = new theme.Product(c);
          }
        }.bind(e));
      });
      var d = this.container.querySelector(".product-grid"), a = this.container.querySelectorAll(f.viewChange);
      this.container.querySelectorAll(f.viewChange).forEach(function(b) {
        b.addEventListener("click", function() {
          a.forEach(function(k) {
            k.classList.remove("is-active");
          });
          b.classList.add("is-active");
          var c = b.dataset.view;
          d.dataset.view = c;
          theme.cart.updateAttribute("product_view", c);
          window.dispatchEvent(new Event("resize"));
        });
      });
    }, initColorSwatch:function() {
      var e = this;
      this.colorSwatches.forEach(function(d) {
        d.classList.contains("color-swatch--filter") || d.addEventListener("mouseenter", function() {
          this.setColorSwatchImage(d);
        }.bind(e));
      });
    }, setColorSwatchImage:function(e) {
      this.colorSwatchImages.forEach(function(b) {
        b.classList.remove("is-active");
      });
      this.colorSwatches.forEach(function(b) {
        b.classList.remove("is-active");
      });
      var d = this.container.querySelector(".product__swatch-image--" + e.dataset.variantId);
      d.style.backgroundImage = "url(" + e.dataset.variantImage + ")";
      d.classList.add("is-active");
      e.classList.add("is-active");
      d = e.dataset.url;
      var a = e.closest(".product__content");
      e = a.querySelector(".product__image-link");
      a = a.querySelector(".product__meta-link");
      e.setAttribute("href", d);
      a.setAttribute("href", d);
    }});
    return g;
  }();
  theme.ProductQuickBuy = function() {
    function g(f) {
      this.container = f;
      this.init();
    }
    g.prototype = Object.assign({}, g.prototype, {init:function() {
      var f = this.container.querySelector("[data-add-to-cart]");
      f ? new theme.AjaxProduct(this.container, ".cart__checkout") : new theme.AjaxProduct(this.container, ".quick-product__btn-submit");
      var e = this.container.querySelector(".quick-product__btn-select");
      null != e && e.addEventListener("change", function(p) {
        this.container.querySelector(".btn").click();
        p.target.selectedIndex = 0;
      }.bind(this));
      var d = this.container.querySelector(".variant-wrapper--dropdown");
      if (null != d) {
        var a = this.container.querySelector(".quick-product__btn"), b = this.container.querySelector("[data-quick-cancel]"), c = d.querySelector("[data-bundle-variant-json]");
        c = JSON.parse(c.innerHTML);
        var k = d.querySelector("[data-bundle-current-variant-json]");
        this.currentVariantObject = JSON.parse(k.innerHTML);
        theme.SetAvailability.init(null, this.currentVariantObject, c, d, "dropdown");
        d.querySelector("[data-bundle-variant-input]");
        c = d.querySelector("[data-bundle-variant-json]");
        c = JSON.parse(c.innerHTML);
        var l = {container:d, enableHistoryState:!1, singleOptionSelector:".bundle-variant-input-wrap", originalSelectorId:d.querySelector("[data-bundle-variant-input]"), variants:c, autoSelection:d.dataset.autoselect}, n = new slate.Variants(l);
        a && a.addEventListener("click", function(p) {
          d.classList.contains("hide") && (d.classList.remove("hide"), a.classList.add("hide"));
        }.bind(this));
        b && b.addEventListener("click", function(p) {
          d.classList.add("hide");
          a.classList.remove("hide");
        }.bind(this));
        f && f.addEventListener("click", function(p) {
          this.container.querySelector("[data-bundle-variant]").value = l.container.dataset.id;
          this.container.querySelector(".btn").click();
        }.bind(this));
        d.addEventListener("change", function(p) {
          theme.SetAvailability.init(null, n.currentVariant, l.variants, l.container, "dropdown");
          this.container.querySelector("[data-bundle-variant]").value = l.container.dataset.id;
          e = this.container.querySelector("#BundleProductVariant-" + d.dataset.index);
        }.bind(this));
      }
    }});
    return g;
  }();
  (function(g) {
    "loading" != document.readyState ? g() : document.addEventListener("DOMContentLoaded", g);
  })(function() {
    theme.sections.register("collection-template", theme.Collection);
    theme.sections.register("collection-sidebar", theme.CollectionSidebar);
    theme.sections.register("product-grid", theme.ProductGrid);
    theme.sections.register("product-quick-shop", theme.ProductQuickBuy);
    theme.sections.register("product-quick-view", theme.ProductQuickView);
  });
})();